const initialState = {
    dataTableList: []
}

const jobReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'FETCH_JOB_TABLE':
            return {
                ...state,
                dataTableList: action.payload
            }
        default:
            return state
    }
}

export default jobReducer
